// src/App.js
import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Feature from './components/Feature';
import Footer from './components/Footer';
import VideoSection from './components/VideoSection';
import Tabs from './components/Tabs'; // Import the Tabs component
import VideoFeed from './components/VideoFeed'; // Import the VideoFeed component
import DetectionOutput from "./components/DetectionOutput";

function App() {
    return (
        <div className="App">
            {/* Header */}
            <Header />

            {/* Hero section */}
            <HeroSection />

            {/* Video Feed Section */}
            <div className="vcontainer">
                <VideoFeed />
                <DetectionOutput />
            </div>

            


            {/* Features section */}
            <section className="features">
                <div className="container">
                    <div className="ag-format-container">
                        <div className="ag-courses_box">
                            {/* Feature component */}
                            <Feature title="Real-time" description="Live feed," />
                            {/* Repeat Feature component for other features */}
                        </div>
                    </div>
                </div>
            </section>

            {/* Tabs for Locations, Stats, Alarms */}
            {/* <Tabs /> */}



            <VideoSection />
            {/* <ProjectDetails /> */}

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default App;
